import React, { useState, useCallback, useEffect } from "react";
import {
  Card,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Stack,
  Typography,
  Box,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  TextField,
  Paper,
  Snackbar,
  Alert,
  InputBase,
} from "@mui/material";
import { CalendarMonth, EditSharp } from "@mui/icons-material";
import Select from "react-select";
import DateRangePicker from "react-daterange-picker";
import { extendMoment } from "moment-range";
import originalMoment from "moment";
import Axios from "axios";

import Sidebar from "../sidebar/sidebar";
import { companylogo } from "../../assets/images";
import { getSecureItem } from "../../utilsFunctions";
import { BaseUrl } from "../../Environment";
import "../OtherIncome/OtherIncome.scss";
import searchicon from "../../assets/images/searchicon.svg";

const moment = extendMoment(originalMoment);

const dateInputStyle = {
  borderWidth: "1px",
  borderColor: "lightgray",
  borderRadius: "4px",
  padding: "10px",
  width: "95%",
};

const planOptions = [
  { label: "Starter", value: "1" },
  { label: "Business", value: "2" },
  { label: "Unlimited", value: "3" },
];

const CustomPayment = () => {
  const [data, setData] = useState([]);
  const [companyIdU, setCompanyIdU] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [planType, setPlanType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [search, setSearch] = useState("");
  const [planId, setPlanId] = useState("");

  const [addUpdateModal, setAddUpdateModal] = useState(false);
  const [startDateRangeModal, setStartDateRangeModal] = useState(false);
  const [endDateRangeModal, setEndDateRangeModal] = useState(false);
  const [startDateRange, setStartDateRange] = useState();
  const [endDateRange, setEndDateRange] = useState();

  const [toast, setToast] = useState({
    open: false,
    msg: "",
    variant: "success",
    time: 2000,
  });

  const getPlanLabel = useCallback(
    (value) =>
      planOptions.find((opt) => opt.value === String(value))?.label || "",
    []
  );

  const fetchCompanies = useCallback(async () => {
    try {
      const token = getSecureItem("token");
      const companyId = getSecureItem("loggedinUserCompany");
      const payload = {
        companyId,
        search,
        planId,
        planStartDateS: startDateRange?.start,
        planEndDateS: startDateRange?.end,
        planStartDateE: endDateRange?.start,
        planEndDateE: endDateRange?.end,
      };
      const res = await Axios.post(`${BaseUrl}/user/getReferredComp`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.data?.data?.length > 0) {
        setData(res.data.data);
      } else {
        setData([]);
      }
    } catch (err) {
      console.error("Failed to fetch companies", err);
    }
  }, [search, planId, startDateRange, endDateRange]);

  useEffect(() => {
    fetchCompanies();
  }, [fetchCompanies]);

  const handleEdit = (row) => {
    setCompanyIdU(row.companyId);
    setCompanyName(row.companyName);
    setPlanType(getPlanLabel(row.planId));
    setStartDate(moment(row.planStartDate).format("YYYY-MM-DD"));
    setEndDate(moment(row.planEndDate).format("YYYY-MM-DD"));
    setAddUpdateModal(true);
  };

  const updateReferredComp = async () => {
    try {
      const token = getSecureItem("token");
      const payload = {
        companyId: companyIdU,
        planStartDate: startDate,
        planEndDate: endDate,
      };

      const res = await Axios.put(`${BaseUrl}/user/updatePlanDates`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });

      if (res.data.data) {
        setToast({
          open: true,
          msg: res.data.message,
          variant: "success",
          time: 3000,
        });
        setAddUpdateModal(false);
        fetchCompanies();
      }
    } catch (err) {
      setToast({
        open: true,
        msg: "Update failed!",
        variant: "error",
        time: 3000,
      });
      console.error("Update error:", err);
    }
  };

  const renderDateRangeModal = (open, setOpen, value, setValue, label) => (
    <Dialog open={open} onClose={() => setOpen(false)}>
      <DialogTitle>Select {label} Date</DialogTitle>
      <DialogContent>
        <DateRangePicker value={value} onSelect={setValue} singleDateRange />
        <Stack spacing={1} mt={1}>
          <Typography textAlign="center" fontSize={15}>
            Start Date:{" "}
            {value?.start ? moment(value.start).format("DD/MM/YYYY") : "-"}
          </Typography>
          <Typography textAlign="center" fontSize={15}>
            End Date:{" "}
            {value?.end ? moment(value.end).format("DD/MM/YYYY") : "-"}
          </Typography>
        </Stack>
      </DialogContent>
    </Dialog>
  );

  return (
    <>
      <Sidebar />

      <Snackbar
        open={toast.open}
        autoHideDuration={toast.time}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
      >
        <Alert
          onClose={() => setToast((prev) => ({ ...prev, open: false }))}
          severity={toast.variant}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {toast.msg}
        </Alert>
      </Snackbar>

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        p="10px 100px"
      >
        <img src={companylogo} alt="logo" />
      </Stack>

      <Stack className="otherincomepage" spacing={1} p="10px 20px 10px 100px">
        <Box sx={{ width: "98%", p: 2, bgcolor: "#fff" }}>
          <Typography fontSize={15} fontWeight={700} mb={1}>
            Filter Other Income
          </Typography>
          <Grid container spacing={2}>
            <Grid item md={4} xs={12}>
              <Select
                options={planOptions}
                value={
                  planId &&
                  planOptions?.filter((data) => data.value == planId)[0]
                }
                onChange={(val) => setPlanId(val.value)}
                placeholder="Select Plan Type"
              />
            </Grid>
            <Grid item md={4} xs={12}>
              <Button
                onClick={() => setStartDateRangeModal(true)}
                variant="outlined"
                fullWidth
                startIcon={<CalendarMonth />}
              >
                {startDateRange?.start && startDateRange?.end
                  ? `${moment(startDateRange?.start).format("LL")} - ${moment(
                      startDateRange?.end
                    ).format("LL")}`
                  : "Select Plan Start-Dates"}
              </Button>
            </Grid>
            {/* planStartDateS: startDateRange?.start,
        planEndDateS: startDateRange?.end,
        planStartDateE: endDateRange?.start,
        planEndDateE: endDateRange?.end */}
            <Grid item md={4} xs={12}>
              <Button
                onClick={() => setEndDateRangeModal(true)}
                variant="outlined"
                fullWidth
                startIcon={<CalendarMonth />}
              >
                {endDateRange?.start && endDateRange?.end
                  ? `${moment(endDateRange?.start).format("LL")} - ${moment(
                      endDateRange?.end
                    ).format("LL")}`
                  : "Select Plan End-Dates"}
              </Button>
            </Grid>
            <Grid item md={4} xs={12}>
              <div
                style={{
                  display: "flex",
                  backgroundColor: "#EFF2FF",
                  borderRadius: "8px",
                }}
              >
                <IconButton className="iconButton" aria-label="search">
                  <img
                    src={searchicon}
                    alt="searchicon"
                    className="iconButton"
                  />
                </IconButton>
                <InputBase
                  className="input"
                  placeholder="Search..."
                  value={search}
                  onChange={(event) => setSearch(event.target.value)}
                />
              </div>
            </Grid>
            <Grid item md={4} xs={12}>
              <Button
                onClick={() => {
                  setPlanId("");
                  setSearch("");
                  setStartDateRange();
                  setEndDateRange();
                }}
                variant="outlined"
                fullWidth
              >
                Reset
              </Button>
            </Grid>
          </Grid>
        </Box>

        <Card sx={{ mt: 1 }}>
          <div className="tableLaylout">
            <Table>
              <TableHead style={{ backgroundColor: "#e1f0fa" }}>
                <TableRow className="tablHeadRowPayment">
                  {[
                    "Company Name",
                    "Plan Type",
                    "Start Date",
                    "End Date",
                    "Actions",
                  ].map((h) => (
                    <TableCell key={h} className="tablHeadCellPayment">
                      {h}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {data.map((row) => (
                  <TableRow key={row.companyId}>
                    <TableCell>{row.companyName}</TableCell>
                    <TableCell>{getPlanLabel(row.planId)}</TableCell>
                    <TableCell>
                      {moment(row.planStartDate).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>
                      {moment(row.planEndDate).format("DD/MM/YYYY")}
                    </TableCell>
                    <TableCell>
                      <IconButton
                        color="primary"
                        onClick={() => handleEdit(row)}
                      >
                        <EditSharp />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
        </Card>
      </Stack>

      {/* Date Modals */}
      {renderDateRangeModal(
        startDateRangeModal,
        setStartDateRangeModal,
        startDateRange,
        setStartDateRange,
        "Start"
      )}
      {renderDateRangeModal(
        endDateRangeModal,
        setEndDateRangeModal,
        endDateRange,
        setEndDateRange,
        "End"
      )}

      {/* Add/Update Dialog */}
      <Dialog
        fullWidth
        maxWidth="sm"
        open={addUpdateModal}
        onClose={() => setAddUpdateModal(false)}
      >
        <DialogTitle>Update Plan Dates</DialogTitle>
        <DialogContent>
          <Paper elevation={3} sx={{ p: 2 }}>
            <Stack spacing={2}>
              <TextField
                label="Company Name"
                fullWidth
                value={companyName}
                disabled
              />
              <TextField
                label="Plan Type"
                fullWidth
                value={planType}
                disabled
              />
              <div>
                <Typography>Plan Start Date</Typography>
                <input
                  type="date"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                  style={dateInputStyle}
                />
              </div>
              <div>
                <Typography>Plan End Date</Typography>
                <input
                  type="date"
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                  style={dateInputStyle}
                />
              </div>
            </Stack>
          </Paper>
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setAddUpdateModal(false)}>
            Cancel
          </Button>
          <Button variant="contained" onClick={updateReferredComp}>
            Update
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CustomPayment;
